// src/automation/AutomationRegistry.js

const registry = {};

export function registerAutomation(event, handler) {
  if (!registry[event]) {
    registry[event] = [];
  }

  registry[event].push(handler);
}

export function getAutomations(event) {
  return registry[event] || [];
}